<template>
    <div class="notification-bid"  :style="btm">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <div class="notification-bid-title">{{ messageTitle }}</div>
                <i
                    class="notification-bid-close el-icon-close"
                    @click="onColse"
                ></i>
            </div>
            <div class="notification-bid-content">
                <div class="notification-content-top">
                    <p>您好！</p>
                </div>
                <div class="notification-content-middle" :style="infoHeight">
                    <p v-for="(item, index) in allList" :key="index">
                        <span>{{ item.messageContent }}</span>
                    </p>
                </div>
            </div>
            <div class="notification-bid-footer">
                <el-button @click="onColse">已知悉</el-button>
                <el-button @click="onRemind">已知悉，无需再次提醒</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import {
    closeInviteTip
} from '../../api/notificationWarn.js';

export default {
    data() {
        return {
            allList: [],
            closeState: false,
            messageState: false,
            messageData: [],
            messageTitle: "消息提示",
            bidNo: "", // 1 表示供应商消息提示、2 表示司机消息提示、3 表示车辆消息提示
            documentEarlyWarningType: "", // 1 表示供应商消息提示、2 表示司机消息提示、3 表示车辆消息提示
            shortList: []
        };
    },
    computed: {
        infoHeight() {
            if (this.allList.length === 1) {
                return "height:72px;";
            }
            if (this.allList.length === 2) {
                return "height:120px;";
            }
            if (this.allList.length >= 3) {
                return "height:205px;";
            }
            return "height:72px;";
        },
        btm() {
            if (this.closeState) {
                return "bottom: -440px;opacity:0;";
            }
            if (this.allList.length === 1) {
                return "bottom: 5px;opacity:1;";
            }
            if (this.allList.length === 2) {
                return "bottom: 54px;opacity:1;";
            }
            if (this.allList.length >= 3) {
                return "bottom: 139px;opacity:1;";
            }
            return "";
        },
    },
    props: {
        bidNoticeData: {
            type: Object,
            default: () => {
            }
        }
    },
    watch: {
        bidNoticeData: {
            handler(val) {
                if (val) {
                    this.allList = [val];
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setMessagePrompt() {
            const messageData = this.messageData;
            if (Array.isArray(messageData) && messageData.length > 0) {
                this.allList = [];
                this.shortList = [];
                const { title, dataList } = messageData[0];
                this.messageTitle = title;
                if (title === '供应商消息提示') {
                    this.documentEarlyWarningType = '1';
                    // const rowData = { content: dataList };
                    // rowData.content = `【aa】证件即将过期，到期时间：bb，请及时更新，到期后系统将强制终止合作，供应商编码${dataList}`;
                    // this.allList.push(rowData);
                    this.allList = dataList;
                    this.shortList = dataList;
                }
            }
        },
        onColse() {
            this.closeState = true;
            const messageData = this.messageData;
            if (Array.isArray(messageData) && messageData.length > 0) {
                messageData.shift();
                if (messageData.length < 1) {
                    return;
                }
                setTimeout(() => {
                    this.closeState = false;
                    this.setMessagePrompt();
                }, 1500);
            }
        },
        onRemind() {
            let bidNo = '';
            if (Array.isArray(this.allList) && this.allList.length > 0) {
                bidNo = this.allList[0].bidNo;
            }
            if (!bidNo) {
                return false;
            }
            const params = {
                supplierCode: this.$store.state.supplier.supplierCode,
                bidNo
            };
            closeInviteTip(params).then(res => {
                if (res && +res.code === 0) {
                    this.onColse();
                }
            });
        },
        onView() {
            this.$refs.notificationDialog.open(this.allList);
        }
    }
};
</script>

<style scoped lang="less">
.notification-bid {
    position: absolute;
    bottom: -440px;
    right: 80px;
    width: 380px;
    height: 208px;
    opacity: 0;
    transition: all 0.8s ease;
    z-index: 9999;

    /deep/.el-card__header {
        padding: 10px 18px;
    }

    &-title {
        // height: 30px;
        // line-height: 30px;
        text-align: center;
        // border: 1px solid blue;
    }

    &-close {
        position: absolute;
        right: 5px;
        top: 10px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
            color: #00bcbf;
        }
    }

    &-content {
        font-size: 12px;

        .notification-content-top {
            display: flex;
            height: 26px;
            align-items: center;
            justify-content: space-between;
        }

        .notification-content-middle {
            overflow: auto;
            p {
                margin: 6px 0;
            }
        }
    }

    &-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 5px 0;
        height: 30px;
        // border: 1px solid blue;
        // line-height: 30px;
        // text-align: center;
    }
}
</style>
